import React, {useState, useCallback} from 'react'
import {PlayerColor} from '@colonist/game-states'
import {PlayerValidator} from '@colonist/game-mechanic-validators'
import {Avatar} from '../../../Avatar/Avatar'
import styles from './UIGameActionBoxPickPlayer.module.scss'
import clsx from 'clsx'
import {UIGameActionBoxBase, UIGameActionBoxBaseProps} from '../../UIGameActionBoxBase'

export interface UIGameActionBoxPickPlayerProps extends UIGameActionBoxBaseProps {
    onConfirm: () => void
    onPlayerSelect?: (player: PlayerColor) => void
    playerValidators: PlayerValidator[]
}

export const UIGameActionBoxPickPlayer = ({
    playerValidators,
    onConfirm,
    onPlayerSelect,
    isConfirmDisabled,
    ...baseProps
}: UIGameActionBoxPickPlayerProps) => {
    const [selectedPlayer, setSelectedPlayer] = useState<PlayerColor | undefined>(undefined)

    const handlePlayerClick = (player: PlayerColor) => {
        setSelectedPlayer(player)
        onPlayerSelect?.(player)
    }

    const noPlayerSelected = selectedPlayer == null
    const shouldDisableConfirm = isConfirmDisabled ? isConfirmDisabled : noPlayerSelected

    const handleConfirm = useCallback(() => {
        if(!noPlayerSelected) onConfirm()
    }, [noPlayerSelected, onConfirm])

    return (
        <UIGameActionBoxBase
            {...baseProps}
            isConfirmDisabled={shouldDisableConfirm}
            onConfirm={handleConfirm}
        >
            <div className={styles.playerGrid}>
                {playerValidators.map((playerValidator) => (
                    <div
                        className={clsx(styles.playerOption, {
                            [styles.selected]: selectedPlayer === playerValidator.color,
                        })}
                        key={playerValidator.color}
                        onClick={() => handlePlayerClick(playerValidator.color)}
                    >
                        <Avatar
                            className={styles.playerAvatar}
                            color={playerValidator.color}
                            image={playerValidator.displayIcon}
                            profilePictureUrl={playerValidator.profilePictureUrl}
                        />
                        <div className={styles.playerName}>
                            {playerValidator.username}
                        </div>
                    </div>
                ))}
            </div>
        </UIGameActionBoxBase>
    )
}
